import BotResponseTreeNode from './BotResponseTreeNode';
import ArithmeticStep from './ArithmeticStep';
import DateStep from './DateStep';

class CalculationTreeNode {
  nextStep: BotResponseTreeNode | null;

  arithmeticStep: ArithmeticStep | null;

  dateStep: DateStep | null;

  resultSlotName: string | null;

  resultSlotType: string | null;

  resultIntentSlotId: number | null;

  constructor(
    nextStep: BotResponseTreeNode | null,
    arithmeticStep: ArithmeticStep | null = null,
    dateStep: DateStep | null = null,
    resultSlotName: string | null = null,
    resultSlotType: string | null = null,
    resultIntentSlotId: number | null = null
  ) {
    this.nextStep = nextStep;
    this.arithmeticStep = arithmeticStep;
    this.dateStep = dateStep;
    this.resultSlotName = resultSlotName;
    this.resultSlotType = resultSlotType;
    this.resultIntentSlotId = resultIntentSlotId;
  }
}

export default CalculationTreeNode;
